import {Fragment, useEffect, useMemo, useRef, useState} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { GlobeEuropeAfricaIcon } from '@heroicons/react/24/outline'
import {useLocation, useNavigate} from "react-router-dom";
import CountrySelector from "./CountrySelector";
import login from "../login/Login";

const countryNames = {
  uk: 'United Kingdom',
  mt: 'Malta',
  ie: 'Ireland',
}

export default function Example() {
  let location = useLocation();
  let navigate = useNavigate()

  const [changed, setChanged] = useState(false)

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode : ''
  const savedCountry = useMemo(() => {
    console.log('changed',changed,localStorage.getItem('country'))
    return localStorage.getItem('country') ?? null
  }, [changed])

  const open = useMemo(() => {
    return !savedCountry && country ? false : country !== savedCountry
  }, [country,savedCountry])

  useEffect(() => {
    console.log({savedCountry, country, open})
    if (location.pathname == '/' && country === '' && savedCountry){
      // redirect to saved country
      navigate("/" + savedCountry)
    }
  },[country,savedCountry])

  const confirmButtonRef = useRef(null)

  if (['login','set'].includes(countryCode)){
    return null
  }

  return (
    <Transition.Root show={open} as={Fragment} onClose={() => {}}>
      <Dialog as="div" className="relative z-10" initialFocus={confirmButtonRef}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                    <GlobeEuropeAfricaIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      Hey buddy,
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Can you help me confirm where you're based?
                      </p>
                    </div>
                  </div>
                </div>
                <div className={`mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense ${country ? 'sm:grid-cols-2' : 'justify-center'} sm:gap-3`}>
                  <CountrySelector onConfirm={(value) => {
                    localStorage.setItem('country', value)
                    // use changed as a toggle for re-render
                    setChanged(value)
                  }} noDefaultSelection={true} />

                  { country &&
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-2 sm:mt-0"
                      /*className="inline-flex w-full justify-center rounded-md bg-employer-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-employer-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600 sm:col-start-2"*/
                      onClick={() => {
                        localStorage.setItem('country', savedCountry ?? country)
                        navigate("/" + savedCountry ?? country)
                      }}
                      ref={confirmButtonRef}
                    >
                      I'm based in {countryNames[savedCountry ?? country]}
                    </button>
                  }
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
